import { gatewayPhone } from "src/gateways/gatewayPhone";
import { gateway } from "../../../../gateway";
import { ContactType, IContact, ICreateContact, IGetContactsResponse, IUpdateContact } from "../../types";

export const getContacts = async (
  companyId: number,
  page?: number,
  limit?: number,
  search?: string,
  type?: ContactType | string | null,
): Promise<IGetContactsResponse> => {
  const token = sessionStorage.getItem("token");
  const headers: Record<string, string> = {};
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const params: Record<string, any> = {};
  if (page !== undefined) params.page = page;
  if (limit !== undefined) params.limit = limit;
  if (search !== undefined && search.trim() !== "") params.search = search;
  if (type !== undefined) {
    if (type) params.type = type;
  } else {
    params.type = ContactType.OTHER;
  }

  const response = await gatewayPhone.get(`/contacts/${companyId}`, {
    headers,
    params,
  });

  return response.data?.data;
};

export const createContact = async (payload: ICreateContact): Promise<IContact> => {
  const token = sessionStorage.getItem("token");
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const response = await gatewayPhone.post("/contacts", payload, {
    headers,
  });

  return response.data?.data;
};

export const updateContact = async (uid: string, payload: IUpdateContact): Promise<IContact> => {
  const token = sessionStorage.getItem("token");
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const response = await gatewayPhone.put(`/contacts/${uid}`, payload, {
    headers,
  });

  return response.data?.data;
};

export const deleteContact = async (uid: string): Promise<void> => {
  try {
    const token = sessionStorage.getItem("token");
    const headers: Record<string, string> = {};
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    const response = await gatewayPhone.delete(`/contacts/${uid}`, {
      headers,
    });

    return response.data?.data;
  } catch (error: any) {
    console.error(`[contacts.actions] Failed DELETE /contacts/${uid}:`, error?.response?.data || error.message || error);
    throw error;
  }
};

export interface ILinkWorkforcePhone {
  countryCode: string;
  dialCode: string;
  phone: string;
  tag: string;
  isDefault: boolean;
}

export const linkWorkforce = async (workforceUid: string, phoneNumbers: ILinkWorkforcePhone[]): Promise<void> => {
  const token = sessionStorage.getItem("token");
  const headers: Record<string, string> = {};
  if (token) {
    headers["Authorization"] = token;
  }

  await gateway.patch(
    `/workforce/`,
    { uid: workforceUid, phoneNumbers },
    {
      headers,
    },
  );
};
